// ─── Venue: Split Luxe ────────────────────────────────────────
// Image left + bordered card right. Dark-theme friendly.
// Luxe feel with rounded corners and gold accent map button.

import React from 'react';
import { MapPin, ArrowRight } from 'lucide-react';
import { AnimatedSection } from '../../../lib/animations/AnimatedSection';

export default function VenueSplitLuxe({ section, data, theme }) {
  const anim = section.animation || {};
  const { venueName, address, mapLink, note, image } = data;

  return (
    <section className="px-6 py-20 sm:py-24" data-testid="venue-section">
      <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-[1.05fr_0.95fr] md:items-center">
        {/* Image */}
        <AnimatedSection preset={anim.section || 'fade-up'}>
          {image && (
            <img
              src={image}
              alt={venueName || 'Venue'}
              className="h-[360px] w-full rounded-[2rem] object-cover sm:h-[500px]"
              loading="lazy"
            />
          )}
        </AnimatedSection>

        {/* Details card */}
        <AnimatedSection preset="fade-in" delay={0.15}>
          <div
            className="rounded-[2rem] border p-8 sm:p-10"
            style={{ backgroundColor: theme.surface, borderColor: theme.border }}
          >
            <p
              className="text-[11px] uppercase tracking-[0.2em] mb-3"
              style={{ color: theme.accent, fontFamily: theme.eyebrowFont }}
            >
              Venue
            </p>
            <h3
              className="text-3xl sm:text-4xl"
              style={{ fontFamily: theme.headingFont, color: theme.textPrimary }}
            >
              {venueName}
            </h3>
            {address && (
              <div className="mt-4 flex items-start gap-3">
                <MapPin className="mt-1 h-5 w-5 flex-shrink-0" style={{ color: theme.accent }} />
                <p style={{ color: theme.textSecondary }}>{address}</p>
              </div>
            )}
            {note && (
              <p className="mt-5 leading-7" style={{ color: theme.textSecondary }}>
                {note}
              </p>
            )}
            {mapLink && (
              <a
                href={mapLink}
                target="_blank"
                rel="noopener noreferrer"
                className="mt-8 inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-medium transition hover:opacity-90"
                style={{ backgroundColor: theme.buttonBg, color: theme.buttonText }}
              >
                Open map
                <ArrowRight className="h-4 w-4" />
              </a>
            )}
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}
